"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllGlobalVirtualCategories = void 0;
const routes_1 = require("../../routes");
const getAllGlobalVirtualCategories = (client) => async () => {
    const url = routes_1.ENDPOINTS.GET_ALL_GLOBAL_VIRTUAL_CATEGORIES.applyParams();
    const response = await client.get(url);
    return response.data;
};
exports.getAllGlobalVirtualCategories = getAllGlobalVirtualCategories;
